import isNil from 'lodash/isNil';
import moment from 'moment';

import ReportFetchResult from './ReportFetchResult';

export default class Report {
  name;
  description;
  fetch;
  columnNames;
  mapFilters;
  rowAction;
  paginationDisabled;
  filters;
  styles;
  showChartDropdown;
  getDefaultDates;
  getColumnNames;
  modals;
  retrieveFiltersWithDefaultValues: (filters: { [key: string]: string }) => {
    [key: string]: string;
  };

  constructor(build) {
    Object.assign(this, build);
  }

  static Builder = class Builder {
    name;
    description;
    fetch;
    columnNames;
    mapFilters;
    rowAction;
    paginationDisabled;
    styles;
    showChartDropdown;
    filters;
    getDefaultDates;
    getColumnNames;
    modals;
    retrieveFiltersWithDefaultValues: (filters: { [key: string]: string }) => {
      [key: string]: string;
    };
    constructor() {
      this.getDefaultDates = () => {
        const now = Date.now();
        const startDate = moment(now).subtract(6, 'days').format('YYYY-MM-DD');
        const endDate = moment(now).format('YYYY-MM-DD');
        return { startDate, endDate };
      };
    }
    setName(name: string): Builder {
      this.name = name;
      return this;
    }
    setDescription(description: string): Builder {
      this.description = description;
      return this;
    }
    setFetchFunction(
      fetch: (
        pageNumber: number,
        filters?: { [key: string]: string }
      ) => Promise<ReportFetchResult>
    ): Builder {
      this.fetch = fetch;
      return this;
    }
    setFiltersMapper(
      mapper: (entries: any) => { [key: string]: string }
    ): Builder {
      this.mapFilters = mapper;
      return this;
    }
    setRowAction(rowAction: any): Builder {
      this.rowAction = rowAction;
      return this;
    }
    setPaginationDisabled(paginationDisabled: boolean): Builder {
      this.paginationDisabled = paginationDisabled;
      return this;
    }
    setStyles(styles: any): Builder {
      this.styles = styles;
      return this;
    }
    setShowChartDropdown(showChartDropdown: boolean): Builder {
      this.showChartDropdown = showChartDropdown;
      return this;
    }
    setFilters(filters: any): Builder {
      this.filters = filters;
      return this;
    }
    setGetDefaultDates(getDefaultDates: () => unknown): Builder {
      this.getDefaultDates = getDefaultDates;
      return this;
    }
    implementGetColumnNames(getColumnNames: () => unknown): Builder {
      this.getColumnNames = getColumnNames;
      return this;
    }
    setModals(modals: any): Builder {
      this.modals = modals;
      return this;
    }
    setRetrieveFiltersWithDefaultValues(
      retrieveFiltersWithDefaultValues: (filters: {
        [key: string]: string;
      }) => {
        [key: string]: string;
      }
    ): Builder {
      this.retrieveFiltersWithDefaultValues = retrieveFiltersWithDefaultValues;
      return this;
    }
    build(): Report {
      if (isNil(this.name)) {
        throw new Error('Name cannot be empty!');
      }

      if (isNil(this.description)) {
        throw new Error('Description cannot be empty!');
      }

      if (isNil(this.mapFilters)) {
        this.mapFilters = entriesToObject;
      }

      if (isNil(this.getDefaultDates)) {
        this.getDefaultDates = () => {
          const now = Date.now();
          const startDate = moment(now)
            .subtract(6, 'days')
            .format('YYYY-MM-DD');
          const endDate = moment(now).format('YYYY-MM-DD');
          return { startDate, endDate };
        };
      }
      if (isNil(this.retrieveFiltersWithDefaultValues)) {
        this.retrieveFiltersWithDefaultValues = (filters) => filters;
      }

      return new Report(this);
    }
  };
}

function entriesToObject(entries) {
  const result = {};
  for (const [key, value] of entries) {
    if (value !== null && value !== undefined) {
      result[key] = value;
    }
  }
  return result;
}
